var windowLoaded = false;
$(window).on("load", function() {
	windowLoaded = true;
});


//ready
$(document).ready(function(){
resizeHero();
});

window.onresize = function(event) {
resizeHero();
}

function resizeHero() {
var rowHeight =$('.hero-boxes .row').outerHeight();
var tfHeight =$('.hero-boxes .twitter-feed').outerHeight();
vph = rowHeight + tfHeight;
$('.hero-boxes').css({'max-height': vph + 'px'});
}
  
if( $('.video-banner').length ){
	var vid = document.getElementById('subpage-video-player');
					var loaded = false;
					vid.oncanplaythrough = function() {
						vid.oncanplaythrough = null;
						if (!loaded) {
							loaded = true;
							vid.currentTime = 0;
							document.getElementById('subpage-video-cover').style.display = 'none';
							vid.style.display = 'block';
							vid.play();
							vid.loop = true;
						}
					}

					function size_video(section) {
						var ratio = 1920/1080;
						var w = section.outerWidth();
						var h = $('.video-banner').height();
						console.log(h)
						section.css('height', h+'px');

						var vid_w = w;
						var vid_h = vid_w / ratio;
						var left = 0;
						var top = -1 * (vid_h - h) / 2;

						if (vid_h < h) {
							vid_h = h;
							vid_w = vid_h * ratio;
							top = 0;
							left = -1 * (vid_w - w) / 2;
						}

						section.find('.video-cover, .video-player').css({
							width: vid_w+'px',
							height: vid_h+'px',
							left: left+'px',
							top: top+'px'
						}).addClass('sized');

					}
					$('document').ready(function() {
						size_video($('#subpage-video'));
					})
					$(window).on('resize load', function() {
						size_video($('#subpage-video'));
					})
}

jQuery(document).ready(function($){
	if($('.episode-image-slider').length) {
		$('.episode-image-slider').slick();
	}

//vars
	var html = $('html');
	var header = $('header');
	var footer = $('footer');
	var delay_default = 300;
	var mediaQuery_mobile = window.matchMedia("(max-width: 1023px)");
	var mediaQuery_tablet = window.matchMedia("(max-width: 1024px)"); 
		//if(mediaQuery_mobile.matches)


//SVG to inline
	inlineSVG.init({
		svgSelector: 'img.svg',
		initClass: 'js-inlinesvg',
	}, function () {
		console.log('All SVGs inlined');
	});


//smooth scroll to
	function smoothScrollTo(target) {
	    $('body, html').stop().animate({
	    	'scrollTop': target.offset().top - header.outerHeight()
	    }, delay_default*3, 'swing');
	}
	
	$('.hamburger').click(function(e) {  
		e.preventDefault();
		//$('.slideout').fadeToggle(250);
		//$('.slideout').animate({right:'0px',top:'0px'}, {queue: false, duration: 500});
		$('.header-overlay').fadeToggle(250);
		
		$('body').addClass('nav-open');
	});
	
	$('.close').click(function(e) {  
		e.preventDefault();
		//$('.slideout').fadeToggle(250);
		 //$('.slideout').hide();
		$('.header-overlay').fadeToggle(250);
		//$('.slideout').animate({right:'-50%',top:'-100vh'}, {queue: false, duration: 500});
		$('body').removeClass('nav-open');
	});
	
	$('.header-overlay').click(function(e) {  
		e.preventDefault();
		//$('.slideout').fadeToggle(250);
		 //$('.slideout').hide();
		$('.header-overlay').fadeToggle(250);
		//$('.slideout').animate({right:'-50%',top:'-100vh'}, {queue: false, duration: 500});
		$('body').removeClass('nav-open');
	});
	
	$('.tab-btn').click(function(e) {  
		e.preventDefault();
		$('.tab-btn').removeClass('active');
		$(this).addClass('active');
		$('.tab').hide();
		var tab =   $(this).data('id');
		$("."+tab).fadeIn(1000);
	});
	$('.season-select').on('change', function() {
		$('.tab').hide();
		var tab = $(this).val();
		$("."+tab).fadeIn(1000);
	});


//scroll to top
    $(window).scroll(function() {
   		if ($(this).scrollTop() >= ($(window).height() - header.outerHeight()) / 2) {     
	        $('#return-to-top').show();
	    } else {
	        $('#return-to-top').hide();
	    }
	});

	$('#return-to-top').click(function(e) {  
		e.preventDefault();
		smoothScrollTo(html);
	});
	
	var winh = $(window).height();
    winh = winh - $('.top-header').outerHeight() + 3;
    if($(window).width() > 1024) {
		if($(window).scrollTop() >= winh) {		
	       $('.top-header').addClass('stick'); 
			check_nav();
		}
	}

    $(window).scroll(function() {
    	if($(window).width() > 1024) {
	        if($(this).scrollTop() >= winh) {
	            $('.top-header').addClass('stick'); 
				check_nav();
	        } else {
	            $('.top-header').removeClass('stick');   
				check_nav();
	        }
    	}
    });


//onScroll
	function onDocumentScroll() {
	}

    $(document).scroll(function() {
		onDocumentScroll();
	});


//documentReady
	console.log('Document Ready');


//onLoad
	function afterLoad() {
		console.log('Window Loaded');
	}


//onResize
	function onWindowResize() {		
	}
	$(window).on('resize', function () {
		onWindowResize();
	});

	
//onLoad triger if not
	if(!windowLoaded)
	    $(window).on("load", afterLoad);
	else
	    afterLoad();

});

//OLD JS
$(function() {
	size_all();

	if ($('.quotes-fader').length) {
		$('.quotes-fader').slick({
			infinite: true,
			speed: 2500,
			fade: true,
			cssEase: 'linear',
			autoplay: true,
			autoplaySpeed: 5700,
			arrows: false
		});
	}

	$('.toggle-mobile-menu').click(function() {
		var body = $('body');
		if (body.hasClass('mobile-menu-expanded')) {
			body.animate({
				right:"0%"
			}, function() {
				body.css("top", "auto").removeClass('mobile-menu-expanded');
				body.scrollTop(body.data('scroll-pos'))
			})
		} else {
			var scroll_pos = body.scrollTop();
			body.addClass('mobile-menu-expanded').data('scroll-pos', scroll_pos).css("top", -1*scroll_pos);
			body.animate({
				right: "57%"
			})
		}
	})

	$('.show-more-media').click(function() {
		var media = $(this).closest('.media-section');
		var per_page = media.data('per-page');
		var next = media.data('next');
		var new_next = next + per_page;

		media.find('.media-item').each(function() {
			var order = $(this).data('order');
			if (order < new_next) {
				//$(this).removeClass('hide').fadeIn(1000);;
				$(this).fadeIn(1000);
			}
		})

		media.data('next', new_next);

		if (new_next > media.data('last')) {
			$(this).closest('.view-more').remove();
		}
	})


	$('.scroll-to').click(function(event) {
		event.preventDefault();
		var target = $($(this).attr('href'));
		var targetHeight = target.offset().top;
		var navHeight = $('.floating-nav').height();
		var navOffest = targetHeight-navHeight;
		$('html,body').animate({
			scrollTop: navOffest
		}, 900);
	});

    var sections = {},
        _height  = $(window).height(),
        _nav_height = $('.floating-nav').height(),
        i        = 0;

    // Grab positions of our sections
    $('.scroll-section').each(function(){
        sections[$(this).attr('id')] = $(this).offset().top;
    });

    $(window).resize(function() {
	    // Grab positions of our sections
	    $('.scroll-section').each(function(){
	        sections[$(this).attr('id')] = $(this).offset().top;
	    });
    })

    $(document).scroll(function(){
        var $this = $(this),
            pos   = $this.scrollTop()
            found = false;

       /* for(i in sections){
            if((sections[i] + _nav_height >= pos && sections[i] <= pos + _height) && !found){
                $('.highlightable').removeClass('active');
                $('.highlightable[href=#'+i+']').addClass('active');
                found = true;
            }
        }*/
    });

    if($('.about-text, .my-story-text').length) {
    	$('.about-text, .my-story-text').mCustomScrollbar({
    		scrollbarPosition: 'outside'
    	});
    }
   if($('#about-home').length) {
    	var img_path = $('#about-home').data('parallax-image');
  		$('#about-home').parallax({imageSrc: img_path});
  	}
  	
}) 
$(window).resize(function() {
		size_all();
})

//check_tbar()
function size_all() {

	if($(window).height() >= 768) {
		size_sections();
	}
	check_nav();
	//check_tbar()
}

function size_sections() {
	$('.window-height').outerHeight($(window).height());
}

function check_nav() {
	var topNav =$('.top-header');
	var navHeight = $('.floating-nav').outerHeight();
	var nav = $('.floating-nav');
	if (nav.length) {
		var h = nav.outerHeight();
		if ($(window).scrollTop()+navHeight >= $('.first-section').outerHeight()-h) {
			nav.addClass('fixed')
			nav.css('top',topNav.outerHeight())
		} else {
			nav.removeClass('fixed');
			nav.css('top','initial')
		}
	}
}
function check_tbar() {
	var tbar = $('.hero-boxes .twitter-feed');
	var tbarH = tbar.outerHeight();
	var footer = $('footer');
	if (tbar.length) {
		footer.css('margin-bottom',tbarH);
	}
}

$(window).scroll(function() {
	check_nav();
});

jQuery(document).ready(function($){
	if( $('.instagram-images').length ){
		var instNum = 1;
		var userFeed = new Instafeed({
			get: 'user',
			userId: '22501492',
			accessToken: '22501492.1677ed0.312c5811b5994e76b814ad807b160544',
			limit: 6,
			resolution: 'standard_resolution',
			orientation: 'square',
			template: '<div class="instagram-image col col-3 img'+instNum+'"><a href="{{link}}" target="_blank"><img src="{{image}}" /></a></div>',
			 after: function() {
				 instNum++;
				 if(instNum > 3){instNum=1;}
				 if (!this.hasNext()) {
					loadButton.setAttribute('disabled', 'disabled');
					loadButton.style.visibility = "hidden";
				}
				 
			 }
		});
		userFeed.run();
	}
});
$(function() {
		$(document).on('click', '.popup-dismiss', function() {	
			$('#newsletter-modal').fadeOut();
			$('.modal-overlay').fadeOut();
		})
		$(document).on('click', '.popup-close-x', function() {
			$('#newsletter-modal').fadeOut();
			$('.modal-overlay').fadeOut();
		})
		$(document).on('click', '.newsletter-popup-btn', function() {
			console.log("click");
			if ($(this).hasClass('disabled')) return false;
			$(this).addClass('disabled');
			var email = $(".newsletter-email").val();
			console.log(email);
			if (validateEmail(email)) {
				$.ajax({
					url: ajaxVars.ajax_url,
					type: 'POST',
					data: {action: 'mc_form_submit', email: email},
					dataType: 'html',
					cache: false,
					success: function(data) {
						console.log(data);
						if (data != "1") {
							$(".popup-content").html("<h3>You Were Already Signed Up To Receive Marnie's Newsletter.</h3>");
							$('.modal-overlay').delay(5000).fadeOut();
							$('#newsletter-modal').delay(5000).fadeOut();
						} else {
							$(".popup-content").html("<h3>Thanks! You Are Signed Up To Receive Marnie's Newsletter!</h3>");
							$('.modal-overlay').delay(5000).fadeOut();
							$('#newsletter-modal').delay(5000).fadeOut();
						}
						
					},
					error: function() {
						alert("There was a problem reaching the server.");
					}
				});
			}
		})
		
		function validateEmail(email) {
			var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		}
	});